import { useParams } from 'react-router';
import PropertyCard from '../components/PropertyCard.jsx';
import { Avatar, EmptyState, ErrorState, Spinner } from '../components/ui.jsx';
import { useFetch, useTitle } from '../lib/hooks.js';
import { formatDate, pluralise } from '../lib/format.js';

const LandlordProfile = () => {
  const { id } = useParams();
  const { data, loading, error, reload } = useFetch(`/landlords/${id}`, [id]);

  useTitle(data?.landlord?.businessName || data?.landlord?.name);

  if (loading && !data) return <Spinner />;
  if (error) {
    return (
      <div className="container section">
        <ErrorState message={error} onRetry={reload} />
      </div>
    );
  }

  const { landlord, listings } = data;

  return (
    <div className="container section">
      <header className="profile-head">
        <Avatar name={landlord.name} url={landlord.avatarUrl} size={84} />
        <div>
          <h1>{landlord.businessName || landlord.name}</h1>
          <p className="muted">
            {landlord.businessName ? `${landlord.name} - ` : ''}
            {landlord.city ? `${landlord.city}, ` : ''}
            member since {formatDate(landlord.memberSince)}
            {landlord.verified ? ' - identity verified' : ''}
          </p>
          {landlord.bio ? <p className="profile-bio">{landlord.bio}</p> : null}
        </div>
      </header>

      <div className="section-head">
        <h2>{pluralise(listings.length, 'listing')} available</h2>
      </div>

      {listings.length === 0 ? (
        <EmptyState title="No live listings" message="This landlord has nothing published at the moment." />
      ) : (
        <div className="card-grid">
          {listings.map((property) => (
            <PropertyCard key={property.id} property={property} />
          ))}
        </div>
      )}
    </div>
  );
};

export default LandlordProfile;
